import { BoundAutocomplete } from "lib/@components/binding/bound-components"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useRefresh } from "lib/@hooks/useRefresh"
import { useState } from "react"
import words from "library/three-words/words.json"

export function Word({ field, textFieldProps = {}, ...props }) {
    const { target } = useBoundContext()
    const refresh = useRefresh()
    const [open, setOpen] = useState(false)
    return (
        <BoundAutocomplete
            field={field}
            filterOptions={startsWith}
            options={words}
            open={open}
            onInputChange={handleInputChange}
            onOpen={openOptions}
            onClose={closeOptions}
            autoComplete
            autoHighlight
            autoSelect
            textFieldProps={{
                ...textFieldProps,
                onBlur: handleBlur,
                onKeyDown: handleKeyDown,
            }}
            {...props}
        />
        // <BoundTextField {...props} />
    )

    function handleInputChange(_, value) {
        commitExactWord(value)
    }

    function handleBlur(event) {
        commitExactWord(event)
        closeOptions()
        textFieldProps.onBlur?.(event)
    }

    function handleKeyDown(event) {
        if (event.key === "Enter") {
            commitExactWord(event)
        }
        textFieldProps.onKeyDown?.(event)
    }

    function commitExactWord(valueOrEvent) {
        const value = valueOrEvent?.target?.value ?? valueOrEvent
        const match = findExactWord(value)
        if (!match || target?.[field] === match) return
        target[field] = match
        refresh()
        closeOptions()
    }

    function startsWith(options, state) {
        const value = state.inputValue.toLowerCase()
        return options.filter((o) => o.toLowerCase().startsWith(value))
    }

    function findExactWord(value) {
        const normalizedValue = value.trim().toLowerCase()
        return words.find((word) => word.toLowerCase() === normalizedValue)
    }

    function openOptions() {
        setOpen(true)
    }

    function closeOptions() {
        setOpen(false)
    }
}
